
import { mapState, mapGetters } from 'vuex'
import bankAccount from '~/mixins/common/bank-account'
import finance from '~/mixins/common/pages/finance'
export default {
    mixins: [finance, bankAccount],
    data() {
        return {
            step: 0,
            steppers: 1,
            formValid: false,
            formData: {
                amount: null,
                currency: null,
            },
            existLoading: false,
            resultData: {},
            amount: '',
            selectedBankId: null,
            pleaseSelectedBankId: false,
        }
    },
    computed: {
        ...mapState({
            loading: (state) => state.themes.withdraw.loading,
            player: (state) => state.player.player,
            verifyCurrency: (state) => state.banks.verifyCurrency,
            cryptoCurrencyList: (state) =>
                state.settings.cryptoWalletAddressList,
            playerCryptoWallets: (state) =>
                state.themes['player-bank'].playerCryptoWallets,
            withdrawalExistingData: (state) =>
                state.themes.withdraw.withdrawalExistingData,
        }),
        ...mapGetters({
            exchangeRates: 'themes/settings/exchangeRate',
            bankAccount: 'themes/player-bank/bankAccount',
            swapAllExchangeRate: 'themes/settings/swapAllExchangeRate',
        }),
        primaryBankAccount() {
            const foundBankAccount =
                this.bankAccount?.player_bank_accounts?.find(
                    (account) => account.is_primary
                )
            return foundBankAccount || {}
        },
        exchangeRate() {
            const foundRate = this.exchangeRates.find(
                (rate) =>
                    rate.from_currency === this.player.currency &&
                    rate.to_currency === this.primaryBankAccount.currency
            )
            return foundRate ? foundRate.rate : 0
        },
        isExchange() {
            if (!this.primaryBankAccount?.currency) return false
            if (this.player.currency === this.primaryBankAccount?.currency)
                return false
            return true
        },
        cryptoExchangeRate() {
            const foundRate = this.swapAllExchangeRate.find(
                (rate) =>
                    rate.from_currency === this.player.currency &&
                    rate.to_currency === this.formData.currency
            )
            if (foundRate) return parseFloat(foundRate.rate)
            return 1
        },
        cryptoTransferAmount() {
            if (!this.formData.amount) return ''
            return this.formatCurrencyJS(
                this.formData.amount * this.cryptoExchangeRate
            )
        },
    },
    watch: {
        'formData.amount'(value) {
            if (value) {
                if (!this.verifyCurrency.withdraw_min) {
                    this.$store.dispatch(
                        'banks/verifyCurrency',
                        this.player.currency
                    )
                }
            }
        },
        cryptoCurrencyList(value) {
            if (value.length) {
                this.formData.currency = value[0].code
            }
        },
        withdrawalExistingData(data) {
            this.checkExistingInitialize(data)
        },
    },
    mounted() {
        this.checkExistingInitialize(this.withdrawalExistingData)
        this.$root.withdrawExistChange = (item) => {
            if (!item?.is_exist) {
                this.steppers = 1
                this.resultData = {}
                this.$emit('enableDisabledPaymentMethod', {
                    is_exist: false,
                })
            }
        }
        if (!this.isInternational && this.player?.currency) {
            this.$store.dispatch('banks/verifyCurrency', this.player.currency)
        }
        if (!this.cryptoCurrencyList.length) {
            this.$store.dispatch('settings/getCryptoWalletAddressList')
        } else {
            this.formData.currency = this.cryptoCurrencyList[0].code
        }
        if (!this.playerCryptoWallets.length) {
            this.$store.dispatch('themes/player-bank/playerCryptoWallet')
        }
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
    },
    destroyed() {
        this.$root.withdrawExistChange = null
    },
    methods: {
        checkExistingInitialize(data) {
            // If no data available and object is empty
            if (!data && Object.keys(data).length === 0) return
            if (!this.player?.has_bank_account) return
            if (data?.is_exist) {
                this.resultData = data
                this.steppers = 2
            }
        },
        async isExists() {
            if (this.player?.has_bank_account) {
                this.existLoading = true
                const result = await this.$store.dispatch(
                    'themes/withdraw/checkExistWithdrawal'
                )
                if (result?.is_exist) {
                    this.resultData = result
                    this.steppers = 2
                }
                this.existLoading = false
            }
        },
        async doWithdraw() {
            if (!this.$refs?.refWithdraw?.validate()) return
            if (!this.formValid) return
            const result = await this.$store.dispatch(
                'themes/withdraw/createCryptoWithdrawal',
                {
                    amount: this.formData.amount,
                    player_crypto_wallet_id:
                        this.formData.player_crypto_wallet_id,
                }
            )
            if (result) {
                this.resultData = result
                this.steppers = 2
                this.$emit('enableDisabledPaymentMethod', {
                    is_exist: true,
                    payment_provider_code: 'crypto',
                })
            }
        },
        clearForm() {
            this.$refs?.refWithdraw?.reset()
        },
        async cancelPending(item) {
            const confirm = window.confirm(this.tl('uSureToCancel?'))
            if (!confirm) return
            const result = await this.$store.dispatch(
                'themes/withdraw/cancelWithdraw',
                item.id
            )
            if (result) {
                this.resultData = {}
                this.steppers = 1
                this.$emit('enableDisabledPaymentMethod', {
                    is_exist: false,
                    payment_provider_code: 'crypto',
                })
                // To clear the existing withdrawal data
                this.$store.commit(
                    'themes/withdraw/setWithdrawalExistingData',
                    {}
                )
            }
        },
        onInputAmount(amount) {
            if (isNaN(amount?.replace(/,/g, ''))) {
                this.formData.amount = '0'
                return
            }
            this.amount = amount
                ? Number.parseFloat(amount?.replace(/,/g, ''))?.toLocaleString()
                : ''
            this.formData.amount = this.amount?.toString()?.replace(/,/g, '')
        },
    },
}
